import * as Types from '../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CsvUploadTaskForListAfBulkSendFragment = { __typename?: 'CsvUploadTask', id: number, filename: string, status: Types.CsvUploadStatus, created: string, processedRowCount: number, rowCount: number, metadata: unknown, processFrom?: string | null, processTo?: string | null, isTest: boolean };

export type CsvUploadTaskListAfBulkSendQueryVariables = Types.Exact<{
  organisationId: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
  cursor?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;


export type CsvUploadTaskListAfBulkSendQuery = { __typename?: 'Query', csvUploadTasks?: { __typename?: 'CsvUploadTasksConnection', totalCount: number, nodes: Array<{ __typename?: 'CsvUploadTask', id: number, filename: string, status: Types.CsvUploadStatus, created: string, processedRowCount: number, rowCount: number, metadata: unknown, processFrom?: string | null, processTo?: string | null, isTest: boolean }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: unknown | null } } | null };

export const CsvUploadTaskForListAfBulkSendFragmentDoc = gql`
    fragment CsvUploadTaskForListAfBulkSend on CsvUploadTask {
  id
  filename
  status
  created
  processedRowCount
  rowCount
  metadata
  processFrom
  processTo
  isTest
}
    `;
export const CsvUploadTaskListAfBulkSendDocument = gql`
    query csvUploadTaskListAFBulkSend($organisationId: String!, $environmentId: String!, $cursor: Cursor) {
  csvUploadTasks(
    first: 20
    after: $cursor
    orderBy: [CREATED_DESC]
    condition: {organisationId: $organisationId, environmentId: $environmentId, taskType: AF_BULK_SEND}
  ) {
    nodes {
      ...CsvUploadTaskForListAfBulkSend
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CsvUploadTaskForListAfBulkSendFragmentDoc}`;

/**
 * __useCsvUploadTaskListAfBulkSendQuery__
 *
 * To run a query within a React component, call `useCsvUploadTaskListAfBulkSendQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsvUploadTaskListAfBulkSendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsvUploadTaskListAfBulkSendQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      environmentId: // value for 'environmentId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCsvUploadTaskListAfBulkSendQuery(baseOptions: Apollo.QueryHookOptions<CsvUploadTaskListAfBulkSendQuery, CsvUploadTaskListAfBulkSendQueryVariables> & ({ variables: CsvUploadTaskListAfBulkSendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CsvUploadTaskListAfBulkSendQuery, CsvUploadTaskListAfBulkSendQueryVariables>(CsvUploadTaskListAfBulkSendDocument, options);
      }
export function useCsvUploadTaskListAfBulkSendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CsvUploadTaskListAfBulkSendQuery, CsvUploadTaskListAfBulkSendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CsvUploadTaskListAfBulkSendQuery, CsvUploadTaskListAfBulkSendQueryVariables>(CsvUploadTaskListAfBulkSendDocument, options);
        }
export function useCsvUploadTaskListAfBulkSendSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CsvUploadTaskListAfBulkSendQuery, CsvUploadTaskListAfBulkSendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CsvUploadTaskListAfBulkSendQuery, CsvUploadTaskListAfBulkSendQueryVariables>(CsvUploadTaskListAfBulkSendDocument, options);
        }
export type CsvUploadTaskListAfBulkSendQueryHookResult = ReturnType<typeof useCsvUploadTaskListAfBulkSendQuery>;
export type CsvUploadTaskListAfBulkSendLazyQueryHookResult = ReturnType<typeof useCsvUploadTaskListAfBulkSendLazyQuery>;
export type CsvUploadTaskListAfBulkSendSuspenseQueryHookResult = ReturnType<typeof useCsvUploadTaskListAfBulkSendSuspenseQuery>;
export type CsvUploadTaskListAfBulkSendQueryResult = Apollo.QueryResult<CsvUploadTaskListAfBulkSendQuery, CsvUploadTaskListAfBulkSendQueryVariables>;